import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { saveReport } from '../../../../utility/apiServices/propertiesServices';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

// MARK: - Report Modal
export function MyModel(props) {
  const [propertyId, setPropertyId] = useState(null);
  const [reason, setReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  const { title, id } = props;

  useEffect(() => {
    setPropertyId(id);
  }, [id]);

  // Define reason options as keys for translation
  const reasonOptions = ["fakeProperty", "overpriced", "fraud", "danger", "other"];

  const validate = () => {
    const newErrors = {};
    if (!reason.trim()) newErrors.reason = t("report.errors.reason");
    if (reason === "other" && !customReason.trim()) newErrors.customReason = t("report.errors.customReason");
    if (!description.trim()) newErrors.description = t("report.errors.description");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validate()) {
      // If "other" is selected, use customReason; otherwise, use the translated reason text
      const finalReason = reason === "other" ? customReason : t(`report.options.${reason}`);
      const data = { propertyId, reason: finalReason, description };
      try {
        const response = await saveReport(data);
        if (!response.status) {
          setReason("");
          setCustomReason("");
          setDescription("");
          Swal.fire({
            icon: "warning",
            text: t("report.alerts.alreadyReported")
          }).then(() => {
            props.onHide();
          });
        } else {
          setReason("");
          setCustomReason("");
          setDescription("");
          Swal.fire({
            icon: "success",
            text: t("report.alerts.reportSuccess")
          }).then(() => {
            props.onHide();
          });
        }
      } catch (error) {
        console.error('Error saving report:', error);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="reasonInput">
            <Form.Label>{t("report.reasonLabel")}</Form.Label>
            <Form.Select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              isInvalid={!!errors.reason}
            >
              <option value="">{t("report.selectReason")}</option>
              {reasonOptions.map((option) => (
                <option key={option} value={option}>
                  {t(`report.options.${option}`)}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.reason}
            </Form.Control.Feedback>
          </Form.Group>

          {reason === "other" && (
            <Form.Group className="mb-3" controlId="customReasonInput">
              <Form.Label>{t("report.customReasonLabel")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("report.customReasonPlaceholder")}
                value={customReason}
                maxLength={50}
                onChange={(e) => setCustomReason(e.target.value)}
                isInvalid={!!errors.customReason}
              />
              <Form.Control.Feedback type="invalid">
                {errors.customReason}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          <Form.Group className="mb-3" controlId="descriptionInput">
            <Form.Label>{t("report.descriptionLabel")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder={t("report.descriptionPlaceholder")}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              isInvalid={!!errors.description}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          {t("report.cancelButton")}
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {t("report.submitReportButton")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
